<template>
  <div class="text-xs-center">
    <v-dialog v-model="open" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{message}}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "SavePopupErrors",
  data() {
    return {
      open: false,
      message: ""
    };
  },
  methods: {
    show(message) {
      this.open = true;
      if (message) {
        this.message = message;
      } else {
        this.message = "Cargando";
      }
    },
    hide() {
      this.open = false;
    }
  }
};
</script>